import React, { useState, useEffect } from 'react'
import {
    ComposedChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from 'recharts';

const GraphCustomer = (props) => {

    useEffect(() => {

    }, [])
    
    return (
            <section className='w-100 sec_graphCustomer cardStyle'>
                <a href="/" className={'btnMore'} />
                <div className='cardContent'>
                    <h1 className='titleCard'>กลุ่มลูกค้า</h1>
                    <div className='subDetail'>
    
                        <p>{props.customer_group.data.group[0].name} <span className='txt-purple2'>{props.customer_group.data.group[0].count}</span> คน</p>
                        <span>/</span>
                        <p>{props.customer_group.data.group[1].name} <span className='txt-purple2'>{props.customer_group.data.group[1].count}</span> คน</p>
                    </div>
                    <div className='graph'>
                        <ResponsiveContainer width="100%" height="100%">
                            <ComposedChart
                            layout="vertical"
                            width={200}
                            height={100}
                            data={props.customer_group.data.chart}
                            margin={{
                                top: 0,
                                right: 50,
                                bottom: 20,
                                left: -20,
                            }}
                            >
                            <CartesianGrid stroke="#fff"/>
                            <XAxis type="number" hide='true' />
                            <YAxis dataKey="name" type="category"  interval={0} width={100} />
                            <Bar dataKey="count" barSize={20} fill="#A737FF" label={{ position: 'right' }}/>
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>

                </div>
            </section>
    )
}
export default GraphCustomer